<template>
  <div>
    <!-- 单商品取消装箱 -->
    <el-dialog :title="$t('message.SingleProductCancellation')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1708px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 数量 -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!-- 商品费用 -->
            <li>{{ $t("message.forGoods") }}</li>

          </ol>


          <ul v-for="(item, index) in selectedList" :key="index">
            <!--   番号-->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <p>{{ item.order_sn }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                      <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 数量 -->
            <li>
              <div>
                <!-- 提出数 -->
                <p>{{ $t("message.putForwardNum") }}：{{ item.submitNum }}</p>
                <!-- 待装箱 -->
                <p>
                  {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
                </p>
                <!-- 已装箱 -->
                <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
                <!-- 已出货 -->
                <!-- <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p> -->
              </div>
            </li>
            <!-- 价格.元 -->
            <li>
              <div>
                <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 箱子列表 -->
      <div class="box">
        <el-button style="margin: 0 0 20px;" type="primary" size="small" @click="allCheck">箱子{{ checked ? '全选取消' : '全选'
          }}</el-button>
        <!-- 箱子列表 -->
        <div class="box-list">
          <div class="item" v-for="(box, boxs) in list" :key="boxs">
            <div class="item-box">
              <el-checkbox v-model="box.checked"> </el-checkbox>
              <div class="item-content">
                <div class="remark">
                  <p class="text-one">
                    NO{{ boxs + 1 }}： {{ $t("message.actualWeight") }}:{{ box.weight }}kg
                  </p>
                </div>
                <div class="NO">
                  {{ box.length }}*{{ box.width }}*{{ box.height }}
                </div>
                <div class="number">
                  当前箱子装箱数量：<span>{{ box.num }}</span>
                </div>
                <div class="num">
                  <span>取出数量:</span> <el-input size="mini" v-model="box.num_out"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 取消移箱 -->
        <el-button type="primary" @click="unpack">
          {{ $t("message.unpack") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :type="5" :shelf_type_set="[1, 2, 3, 4]"
      :cancelEncasementData="cancelEncasementData" />
  </div>
</template>
<script>
import warehouse from "@/components/common/warehouse";
import { mapState } from "vuex";
export default {
  components: {
    warehouse,
  },
  props: {
    selectedList: { type: Array },

  },
  data() {
    return {
      checked: false,
      dialogVisible: false,
      porder_sn: this.$route.query.porder_sn,
      warehouseDialogVisible: false, //仓库
      cancelEncasementData: {}, //取消装箱数据
      id: "",
      list: [],
    };
  },
  computed: {
    ...mapState({
      boxDetail: (state) => state.porderDetail.boxDetail,
      boxList: (state) => state.porderDetail.boxList,
      boxStatus: (state) => state.porderDetail.boxStatus,
      status: (state) => state.porderDetail.status,
      boxIds: (state) => state.porderDetail.boxIds,
    }),

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.goodsFreightDetailBatch()
      }
    }
  },
  created() { },
  methods: {
    goodsFreightDetailBatch() {
      let datas = {
        freight_id_set: this.boxIds,
        order_detail_id: this.selectedList[0].order_detail_id
      };
      this.list = []
      this.$api.porderApi.goodsFreightDetailBatch(datas).then((res) => {
        res.data.forEach(item => {
          item.porder_freight_detail.forEach(items => {
            let orderItem = this.selectedList.find(order => order.order_detail_id == items.order_detail_id)
            if (orderItem) {
              let boxData = JSON.parse(JSON.stringify(item))
              boxData.num = items.num
              boxData.num_out = items.num
              boxData.checked = false
              this.list.push(boxData)
            }
          })
        })
      });
    },
    //装箱数最大数
    maxNum(proderIndex, index, purchaseIndex) {
      let item =
        this.boxDetail.list[proderIndex].list[index].list[purchaseIndex];
      if (item.cancelEncasementNum > item.num) {
        item.cancelEncasementNum = item.num;
        this.$message.error("移箱数量不能大于本箱装货数");
        this.$forceUpdate();
      }
    },
    // 取消装箱
    unpack() {
      let list = []
      this.list.forEach(item => {
        if (item.checked) {
          list.push({ freight_id: item.id, num_out: item.num_out })
        }
      })
      if (list == false) return this.$message.error('请选择需要一键移出货物的箱子')
      this.cancelEncasementData = {
        grid_number: '',
        porder_sn: this.porder_sn,
        order_detail_id: this.selectedList[0].order_detail_id,
        list
      }
      this.warehouseDialogVisible = true;
    },
    // 取出箱子成功
    takeOutSucess() {
      this.dialogVisible = false;
      this.warehouseDialogVisible = false;
      this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
    },
    //
    allCheck() {
      this.checked = !this.checked

      this.list.forEach(item => {
        item.checked = this.checked
      })
      this.$forceUpdate()

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .table {
    .head {
      line-height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #dedede;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}

.box {
  border-radius: 8px;
  margin: 24px 15px 0;

  .box-title {
    text-align: center;
    margin: 48px 0 24px;
    font-size: 18px;
  }

  h6 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 8px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
            margin-bottom: 10px;
          }

          .num {
            display: flex;
            line-height: 28px;

            span {
              display: flex;
              width: 110px;
              margin-right: 12px;
            }
          }

          .number {
            margin-bottom: 10px;

            span {
              color: red;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
